import { useState } from 'react'

export const useCopyToClipboard = (criteria?: (text: string) => boolean) => {
  const [copied, setCopied] = useState<string>()

  const copyToClipboard = (text: string) => {
    if (criteria && !criteria(text)) return

    navigator.clipboard.writeText(text)
    setCopied(text)

    window.getSelection()?.removeAllRanges()

    setTimeout(() => {
      setCopied(undefined)
    }, 3000)
  }

  return {
    copied,
    copyToClipboard,
  }
}
